<template>
  <AppIcon 
    icon="mdi:chevron-down"
    :class="expanded ? 'opened' : 'closed'"
    :size="18"
  />
</template>

<script setup lang="ts">
defineProps<{
  expanded: boolean;
}>();
</script>

<style scoped>
.opened, .closed {
  transition: transform 0.3s ease;
}
.opened {
  transform: rotate(180deg);
}
.closed {
  transform: rotate(0deg);
}
</style>
  